import React, { useRef } from 'react';

import { Text, Input, useToast } from '@chakra-ui/react';
import { useMutation } from 'react-query';

import { Button, Icon } from 'components';
import { translatedNames } from 'constants/routes';
import { importFn } from 'constants/table';

export default function ImportFile({
  content,
  onSuccess,
  ...rest
}) {
  const ref = useRef(null);
  const toast = useToast();

  const {
    mutate,
    isLoading,
  } = useMutation((file: File) => {
    const formData = new FormData();
    formData.append('data', file);

    return importFn[content]({ data: formData });
  }, {
    onSuccess: () => {
      toast({
        title: 'Salvo com sucesso!',
        description: `Os ${translatedNames[content]} foram importados`,
        status: 'success',
        duration: 5000,
        position: 'top-right',
        isClosable: true,
      });
      onSuccess();
    },
    onError: (error: any) => {
      if (error.errors) {
        error.errors?.map(({ message }) => toast({
          title: 'Ocorreu um erro!',
          description: message,
          status: 'error',
          duration: 5000,
          position: 'top-right',
          isClosable: true,
        }));
      } else {
        toast({
          title: 'Ocorreu um erro!',
          description: error.message,
          status: 'error',
          duration: 5000,
          position: 'top-right',
          isClosable: true,
        });
      }
    },
  });

  return (
    <>
      <Input
        type="file"
        ref={ref}
        hidden
        name="dataImport"
        accept=".csv"
        onChange={(event) => mutate(event.target.files[0])}
      />
      <Button
        mr={4}
        isLoading={isLoading}
        onClick={() => ref?.current?.click()}
        size="xs"
        _hover={{ bg: 'gray.200' }}
        bg="white"
        {...rest}>
        <Icon
          mr={2}
          color="gray.500"
          name="file-upload"
        />
        <Text
          variant="xSmallBold"
          color="gray.500">
          Importar
        </Text>
      </Button>
    </>
  );
}
